import { render, staticRenderFns } from "./RewardModal.vue?vue&type=template&id=c833eade&scoped=true"
import script from "./RewardModal.vue?vue&type=script&lang=js"
export * from "./RewardModal.vue?vue&type=script&lang=js"
import style0 from "./RewardModal.vue?vue&type=style&index=0&id=c833eade&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c833eade",
  null
  
)

export default component.exports